//'use client'
//import { usePathname } from 'next/navigation'

export function capitalizaFirstLetter(str) {
  const capitalize = str.charAt(0).toUpperCase() + str.slice(1);
  return capitalize;
}

export function getCurrentDateInput(nday = 0) {
  const dateObj = new Date();

  // get the month in this format of 04, the same for months
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  const day = ("0" + (dateObj.getDate() + nday)).slice(-2);
  const year = dateObj.getFullYear();

  const shortDate = `${year}-${month}-${day}`;

  return shortDate;
  //setDate(shortDate);
}

export function getCurrentTimeInput() {
  const dateObj = new Date();
  return dateObj.toISOString().substring(11, 16);
}

export function islinkactive(url) {
  // let pathName = window.location.pathname;
  /*
 const pathname = usePathname()
  let isurlinclude = pathName.includes(url);
  return isurlinclude ? "nav-link active" : "nav-link";
  */
  return "nav-link";
}

export function ismenuopen(url) {
  // let pathName = window.location.pathname;
  /*
 const pathname = usePathname()
  let isurlinclude = pathName.includes(url);
  return isurlinclude
    ? "nav-item has-treeview menu-open"
    : "nav-item has-treeview";
*/
  return "nav-item has-treeview";
}

export function returnurl() {
  return "http://localhost:3000";
}
